import {SpavaObj, Image} from './SpavaObj'
import {Vehicle} from './PassControl'
import {time} from '../ladmin/utils'
import {Template} from './Message'

export const ORDER_TOKEN = 'ORDER_TOKEN'

class Result extends SpavaObj {
  // 评论
  comment
  // 类型
  type
  // 地区
  area
  // 图片列表
  imageList

  time

  constructor (o = {}) {
    if (o instanceof Result) return o
    super(o)
    this.comment = o.comment || ''
    this.type = o.type instanceof ViolationRule ? o.type : o.type instanceof Object ? new ViolationRule(o.type) : null
    this.area = o.area || ''
    this.imageList = o.imageList instanceof Array ? o.imageList.slice(0) : []
  }

  get typeName () {
    return this.type && this.type.name
  }

  get typeId () {
    return this.type && this.type.id
  }

  static fromAPI (o) {
    if (!(o instanceof Object)) {
      o = {}
    }
    let r = new Result(o)
    r.comment = o.msg || ''
    r.creationTime = time.toTimeStamp(o.time)
    r.imageList = o.pic instanceof Array ? o.pic.map(p => new Image({url: p})) : []
    return r
  }
}

class ViolationRule extends SpavaObj {
  name
  code
  level
  description
  severity = 0
  max = 0
  templates = []
  parent = this
  detectionId = ''

  constructor (o = {}) {
    super(o)
    this.name = o.name || ''
    this.code = o.code || ''
    this.level = o.level || ''
    this.severity = Number(o.severity) || 0
    this.description = o.description || ''
    this.max = o.max || 0
    this.templates = o.templates instanceof Object ? Object.assign({}, o.templates) : {}
    this.detectionId = o.detectionId || ''
  }

  get isRoot () {
    return this.parent === this
  }

  static fromAPI (o, groups) {
    Object.assign(o, o.rule || {})
    let detection = o.detection || {}
    o.max = detection.maxToBan || 0
    o.severity = o.severityDegree
    o.level = o.codeLevel
    o.detectionId = detection.id || ''
    try {
      let t = JSON.parse(detection.msgTmpltSet || '{}')
      // 暂时不区分类型
      o.templates = {
        sms: Object.keys(t).map(gid => {
          let g = groups.find(group => group.id === gid)
          return {
            id: g && g.id,
            name: g && g.name,
            templates: t[gid].map(s => {
              return new Template({
                id: s.imtpl,
                name: s.imtplName,
                variantList: Object.keys(s.token_list).map(key => ({key, value: s.token_list[key]}))
              })
            })
          }
          // 过滤无效分组
        }).filter(g => !!g.id)
      }
    }
    catch (e) {
      console.warn('JSON parse error', e)
    }
    // console.log('new', new ViolationRule(o))
    return new ViolationRule(o)
  }
}

// class Evidence extends SpavaObj {
//   static VIOCE
//   static IMAGE
//
//   name = ''
//   type = ''
//   data = null
//
//   constructor (o, type) {
//     super(o)
//     if (o instanceof Object) {
//       this.type = type || o.type
//       this.name = o.name || ''
//       this.data = o.data || null
//     }
//   }
//
//   static fromAPI (o, type) {
//     return new Evidence(o, type)
//   }
// }
export const VIOLATION_ROLE = {
  TRAFFIC_ADMIN: 'spava:violation:traffic',
  ALARM_ADMIN: 'spava:violation:center',
  VIOLATION_ADMIN: 'spava:violation:admin'
}
export const VIOLATION_ROLE_TEXT = {
  [VIOLATION_ROLE.TRAFFIC_ADMIN]: '交通管理员',
  [VIOLATION_ROLE.ALARM_ADMIN]: '报警中心管理员',
  [VIOLATION_ROLE.VIOLATION_ADMIN]: '违章管理员'
}
export const RoleSequence = [
  VIOLATION_ROLE.TRAFFIC_ADMIN,
  VIOLATION_ROLE.ALARM_ADMIN,
  VIOLATION_ROLE.VIOLATION_ADMIN
]

class ViolationEvent extends SpavaObj {
  static NOT_SUBMIT = -2
  static HAS_SUBMITTED = 0
  static NEED_PRELIMINARY_CONFIRM = 0
  static HAS_PRELIMINARY_CONFIRMED = 1
  static NEED_FINAL_CONFIRM = 1
  static HAS_FINAL_CONFIRMED = 2
  static HAS_REVOKED = -1

  vehicle
  status = ViolationEvent.NOT_SUBMIT
  results = {}
  submitBy = null
  appointmentOrgId = ''
  passRuleType = ''

  constructor (o) {
    if (o instanceof ViolationEvent) return o
    super(o)
    if (!(o instanceof Object)) {
      o = {}
    }
    this.vehicle = new Vehicle(o.vehicle)
    this.status = o.status
    this.appointmentOrgId = o.appointmentOrgId || ''
    this.passRuleType = o.passRuleType || ''

    RoleSequence.forEach(role => {
      this.results[role] = new Result(o[role])
    })
  }

  static fromAPI (o) {
    let v = new ViolationEvent(o)
    // 事件中的信息根据status决定赋给哪个result
    let resultTo = {
      [ViolationEvent.HAS_SUBMITTED]: VIOLATION_ROLE.TRAFFIC_ADMIN,
      [ViolationEvent.HAS_PRELIMINARY_CONFIRMED]: VIOLATION_ROLE.ALARM_ADMIN,
      [ViolationEvent.HAS_FINAL_CONFIRMED]: VIOLATION_ROLE.VIOLATION_ADMIN,
      [ViolationEvent.HAS_REVOKED]: VIOLATION_ROLE.VIOLATION_ADMIN
    }
    let results = {}
    try {
      results = JSON.parse(o.handlingResult)
    }
    catch (e) {
      console.warn(e)
    }
    v.results[VIOLATION_ROLE.TRAFFIC_ADMIN] = Result.fromAPI(results.trafficController)
    v.results[VIOLATION_ROLE.ALARM_ADMIN] = Result.fromAPI(results.alarmCenter)
    v.results[VIOLATION_ROLE.VIOLATION_ADMIN] = Result.fromAPI(results.admin)
    v.vehicle = new Vehicle({plate: o.violatorObjectId})
    v.status = o.status

    // 类型
    let role = resultTo[v.status]
    if (role) {
      v.results[role].type = new ViolationRule({id: o.viogrpId, name: o.violationTypeName})
    }

    return v
  }

  get plate () {
    return this.vehicle && this.vehicle.plate
  }

  set plate (v) {
    if (!this.vehicle) {
      this.vehicle = new Vehicle()
    }
    this.vehicle.plate = v
  }

  get imageList () {
    let list = []
    RoleSequence.forEach(role => {
      list.push(...this.results[role].imageList)
    })
    return list
  }

  get typeName () {
    return this.type && this.type.name
  }

  get typeId () {
    return this.type && this.type.id
  }

  get type () {
    for (let i = RoleSequence.length - 1; i >= 0; --i) {
      // 根据优先级判断返回
      let role = RoleSequence[i]
      if (this.results[role].type) {
        return this.results[role].type
      }
    }
  }

  get area () {
    for (let i = RoleSequence.length - 1; i >= 0; --i) {
      // 根据优先级判断返回
      let role = RoleSequence[i]
      if (this.results[role].area) {
        return this.results[role].area
      }
    }
  }

  get description () {
    return this.results[VIOLATION_ROLE.TRAFFIC_ADMIN].comment
  }

  // 依照各个角色依次计算合成区域，描述，类型
}

export const VIOLATION_STATUS_TEXT = {
  [ViolationEvent.NOT_SUBMIT]: '待提交', // -2
  [ViolationEvent.HAS_SUBMITTED]: '已提交', // 0
  [ViolationEvent.HAS_PRELIMINARY_CONFIRMED]: '初步确认', // 1
  [ViolationEvent.HAS_FINAL_CONFIRMED]: '已确认', // 2
  [ViolationEvent.HAS_REVOKED]: '已撤销'
}

export {
  ViolationEvent,
  ViolationRule,
  Result
}
